import { List, Typography, Card } from 'antd';
import step1 from './Images_YouTube/YouTubeHomeScreen_Final.jpeg';
import step2 from './Images_YouTube/YouTubeUserScreen_Final.jpeg';
import step3 from './Images_YouTube/YouTubeSettings.jpg';
import step4 from './Images_YouTube/YouTubeDashboard.jpg';
import step5 from './Images_YouTube/YouTubeNewExport1.jpg';
import step6 from './Images_YouTube/YouTubeExportOptions1.jpg';
import step7 from './Images_YouTube/YouTubeNewExport2.jpg';
import step8 from './Images_YouTube/YouTubeExportOptions2.jpg';
import step9 from './Images_YouTube/YouTubeNewExport3.jpg';
import step10 from './Images_YouTube/YouTubeCreateExport.jpg';
import './Request.css';

const { Text, Link, Title } = Typography;

const data = [
    {
        title: 'Step 1',
        image: step1,
        description: 'Press your avatar in the bottom right of the YouTube home page to open your Profile page'
    },
    {
        title: 'Step 2',
        image: step2,
        description: 'Press "Settings" in the top right of your Profile page.'
    },
    {
        title: 'Step 3',
        image: step3,
        description: 'Press "Your data in YouTube" inside your "Settings" page.'
    },
    {
        title: 'Step 4',
        image: step4,
        description: 'Press "Download your YouTube data" option inside "Your YouTube dashboard". If you do not see this option, press on "More" first and it will appear.'
    },
    {
        title: 'Step 5',
        image: step5,
        description: 'On the "Google Takeout" page, scroll down to find the "CREATE A NEW EXPORT" section. Ensure that the box next to "YouTube and YouTube Music" is checked, and then press the "Multiple formats" button.'
    },
    {
        title: 'Step 6',
        image: step6,
        description: 'On the "YouTube and YouTube Music options" pop-up menu, change the file type for "history" from HTML to JSON, then press "OK".'
    },
    {
        title: 'Step 7',
        image: step7,
        description: 'Now, press on the "All YouTube data included" to open a new pop-up menu.'
    },
    {
        title: 'Step 8',
        image: step8,
        description: 'On the "YouTube and YouTube Music content options" pop-up menu, scroll down and uncheck "videos", then press "OK".'
    },
    {
        title: 'Step 9',
        image: step9,
        description: 'Press "Next Step".'
    },
    {
        title: 'Step 10',
        image: step10,
        description: <div><Text>Choose the delivery method that suits you best, and then select "Create export". Your data should become ready shortly, and you will be notified via your chosen delivery method. Download the attached files, and proceed to the </Text>
            <Link href="/donate" target="_blank">
                Data Donation page
            </Link>
            <Text> on this site to submit your data.</Text></div>
    }
];

export const YouTubeRequest = () => {
    return (
        <div>
            <Title>How to Request Your YouTube Data</Title>
            <List grid={{ gutter: 16, column: Math.floor((window.innerWidth) / 260) }}
                dataSource={data}
                renderItem={item => (
                    <List.Item>
                        <Card title={item.title} cover={<img className="RequestCardImageMobile" src={item.image} />} >{item.description}</Card>
                    </List.Item>
                )} />
        </div>
    );
}

export default YouTubeRequest;